import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../../components/Loader/Loader';
import {checkIfHasPermissions} from '../../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../../components/PageContent/PageContent';
import FranchiseTable from '../../../../components/Table/FranchiseTable';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
import Tabs from '../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../constants/permissionsEnum';
import {Itabs} from '../../../../interface/Tab';
import TranslatedText from '../../../../libraries/I18N/TranslatedText';
import cityJSON from '../../../../services/modules/JSON/cityJSON';
import country from '../../../../services/modules/JSON/country';
import statesJSON from '../../../../services/modules/JSON/statesJSON';
import Year from '../../../../shared/Year';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

import DownStream from './Utils/DownStream';
import Upstream from './Utils/Upstream';

const AssetManagement: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const AMTab: Itabs[] = [
    {
      id: 'upstream',
      name: <TranslatedText translationKey="Upstream Leased Asset" />,
      component: (
        <Upstream
          selectedYear={selectedYear}
          planPropertyKey={accessModule.scope3}
          planVehicleKey={accessModule.scope3}
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerAssetsUpstreamLeased
      )
    },
    {
      id: 'downStream_scope3',
      name: <TranslatedText translationKey="Downstream Leased Asset" />,
      component: (
        <DownStream
          selectedYear={selectedYear}
          isAssetManager={true}
          planPropertyKey={accessModule.scope3}
          planVehicleKey={accessModule.scope3}
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerAssetsDownstreamLeased
      )
    },
    {
      id: 'franchise_scope3',
      name: <TranslatedText translationKey="Franchise" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <FranchiseTable selectedYear={selectedYear} isAssetManager={true} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerFranchise)
    }
  ].filter((item) => !item.hidden);

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    Promise.all([country(), statesJSON(), cityJSON()])
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <PageContent>
      {searchParam.get('selectedYear') && (
        <>
          <MainTableTitle title="Asset & Franchises" />
          <Year setSelectedYear={setSelectedYear} />
          <Tabs array={AMTab} />
        </>
      )}
    </PageContent>
  );
};

export default AssetManagement;
